import React from 'react'
import styles from './IconButton.module.scss'

type Variant = 'ghost' | 'outline' | 'error'
type Size = 'xs' | 'sm' | 'md'

interface IconButtonProps {
  icon: React.ReactNode
  label: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  variant?: Variant
  size?: Size
  disabled?: boolean
  className?: never
}

const variantMap: Record<Variant, string> = {
  ghost: styles.ghost, outline: styles.outline, error: styles.error,
}

const sizeMap: Record<Size, string> = { xs: styles.xs, sm: styles.sm, md: styles.md }

export const IconButton: React.FC<IconButtonProps> = ({
  icon, label, onClick, variant = 'ghost', size = 'sm', disabled = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    title={label}
    className={[styles.button, variantMap[variant], sizeMap[size]].join(' ')}
  >
    {icon}
  </button>
)
